import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useUserStore } from "../zustand/UserStore";
import { getNavigationPermissions } from "../hooks/useAuthorization";
import AnalysisLoader from "../components/analysis/AnalysisLoader";
import { getApiBaseUrl } from "../utils/config";

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const setUser = useUserStore((set) => set.setUser);
  const user = useUserStore((set) => set.user);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setLoading(false);
        navigate("/auth");
        return;
      }

      try {
        const response = await axios.get(`${getApiBaseUrl()}/api/v1/auth/verify-user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);

      } catch (err) {
        console.error('Token verification failed:', err);
        localStorage.removeItem("token");
        navigate("/auth");
      } finally {
        setLoading(false);
      }
    };

    // Only check auth if we don't have a user in the store
    if (!user) {
      checkAuth();
    } else {
      setLoading(false);
    }
  }, []); // Remove all dependencies to only run once

  // Handle route redirection separately without triggering auth check
  useEffect(() => {
    if (user && location.pathname === "/" && user.role) {
      const navPermissions = getNavigationPermissions(user.role as any, user.uid);
      navigate(navPermissions.defaultRoute);
    }
  }, [user, location.pathname, navigate]);

  if (loading) return <AnalysisLoader />;

  return <>{children}</>;
};

export default AuthGuard;
